/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebAuthnCreateChallengeAllOf
 */
export interface WebAuthnCreateChallengeAllOf {
    /**
     * The "Options for Credential Creation" as described by the WebAuthn spec at https://www.w3.org/TR/webauthn/#dictionary-makecredentialoptions
     * @type {object}
     * @memberof WebAuthnCreateChallengeAllOf
     */
    options?: object;
}

/**
 * Check if a given object implements the WebAuthnCreateChallengeAllOf interface.
 */
export function instanceOfWebAuthnCreateChallengeAllOf(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebAuthnCreateChallengeAllOfFromJSON(json: any): WebAuthnCreateChallengeAllOf {
    return WebAuthnCreateChallengeAllOfFromJSONTyped(json, false);
}

export function WebAuthnCreateChallengeAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebAuthnCreateChallengeAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'options': !exists(json, 'options') ? undefined : json['options'],
    };
}

export function WebAuthnCreateChallengeAllOfToJSON(value?: WebAuthnCreateChallengeAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'options': value.options,
    };
}

